const { createApp: createIngApp } = Vue;

var app_ingredients_list
app_ingredients_list = createIngApp({
  data() {
	  return {
      all_ingredients: [],
      product_options: {},
      selected_product: null,
      selected_title: null,
	  }
  },
  watch: {
    ingredients_of_product: {
      handler(val) {
        console.log('product ingredients: ', JSON.stringify(val))
      },
      deep: true,
    }
  },
  computed: {
    has_all_ingredients() { return Array.isArray(this.all_ingredients) && this.all_ingredients.length },
    arr_product_options() {return Object.values(this.product_options)},
    has_product_options() { return Array.isArray(this.arr_product_options) && this.arr_product_options.length },
    ingredients_of_product() {
      if(this.selected_product) {
        return this.all_ingredients.filter(i => {
          return typeof Object.keys(i.amounts).find(p => p === this.selected_product) !== 'undefined'
        })
      }
      return this.all_ingredients
    },
    page_title() {
      if(this.selected_product) {
        return `Ingredients in ${this.selected_title}`
      }
      return 'All Ingredients'
    }
  },
  methods: {
    retrieveSelected() {
      let url = new URL(window.location.href);
      let solution = url.searchParams.get('solution');
      let sp, spt = ''
      if(solution) {
        let l_to_short = this.retrieveProductShort(solution);
        Object.entries(this.product_options).forEach(p_ent => {
          let p_key = p_ent[0]
          let p_value = p_ent[1]
          if(p_key === l_to_short && p_value && typeof p_value[name] !== undefined) {
            sp = p_key
            spt = p_value.name
          }
        })
      }
      this.selectProduct(sp, (spt || ''))
    },
    selectProduct(p_key, p_name) {
      this.selected_product = p_key
      this.selected_title = p_name
      let url = new URL(window.location.href);
      if(p_key) {
        url.searchParams.set('solution', this.retrieveProductHuman(p_key));
      }
      else {
        url.searchParams.delete('solution');
      }
      history.replaceState(history.state, '', url.href);
    },
    retrieveProduct(product_title) {
      product_title = product_title.toLowerCase();
      switch (true) {
        case product_title.includes('pineapple crush'):
          return "Pineapple Crush";
        case product_title.includes('perfectly peach'):
          return "Per&shyfect&shyly Peach";
        case product_title.includes('apple pie'):
          return "Apple Pie";
        case product_title.includes('berry fusion'):
          return "Berry Fusion";
        case product_title.includes('cherry surge'):
          return "Cherry Surge";
        case product_title.includes('strawberry lemonade'):
          return "Straw&shyber&shyry Le&shymo&shynade";
        case product_title.includes('advantage'):
          return "Advantage";
        case product_title.includes('discovery pack'):
          return "Dis&shycovery Pack";
        case product_title.includes('better than - ashwagandha'):
        case product_title.includes('better than ashwagandha'):
          return "Ash&shywa&shygan&shydha";
        case product_title.includes('better than - glutathione'):
        case product_title.includes('better than glutathione'):
          return "Glu&shyta&shythi&shyone";
        case product_title.includes('better than - resveratrol'):
        case product_title.includes('better than resveratrol'):
          return "Res&shyve&shyrat&shyrol";
        case product_title.includes('cheat'):
          return "Cheat";
        case product_title.includes('lucid'):
          return "Lucid";
        case product_title.includes('pro'):
          return "Pro";
        case product_title.includes('shield'):
          return "Shield";
        case product_title.includes('sprint'):
          return "Sprint";
        case product_title.includes('zeus'):
          return "Zeus";
        default:
          return "Unknown";
      }
    },
    retrieveProductHuman(p_key) {
      p_key = p_key.toLowerCase();
      switch (true) {
        case p_key.includes('bta'):
          return "ashwagandha";
        case p_key.includes('btg'):
          return "glutathione";
        case p_key.includes('btr'):
          return "resveratrol";
        default:
          return p_key;
      }
    },
    retrieveProductShort(p_key) {
      p_key = p_key.toLowerCase();
      switch (true) {
        case p_key.includes('ashwagandha'):
          return "bta";
        case p_key.includes('glutathione'):
          return "btg";
        case p_key.includes('resveratrol'):
          return "btr";
        default:
          return p_key;
      }
    },
  },
  mounted() {
    this.all_ingredients = effic_all_ingredients.filter(eai => Object.values(eai.amounts).length);
    this.product_options = effic_ing_products;
    //console.log(`this.all_ingredients: ${JSON.stringify(this.all_ingredients)}`)
    this.retrieveSelected()
  }
});

app_ingredients_list.mount('#app_ingredients-list');